import useSWR, { SWRResponse } from "swr";
import { IUseAllBanks } from "./types";
import commonSwrConfig from "../commonSwrConfig";
import { useSession } from "@portal/auth/client/SessionProvider";
import { commonFetcher } from "../common/commonFetcher";
import { IBankItem } from "@portal/types/api/IBankItem";
import { NORNE_CENTERID } from "@portal/assets/banks";

const useAllBanks: IUseAllBanks = () => {
  const { update } = useSession();

  const { data, isLoading, error }: SWRResponse<IBankItem[], unknown> = useSWR(
    `/api/banks/all-banks`,
    commonFetcher<IBankItem[]>,
    {
      ...commonSwrConfig(update),
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      revalidateOnMount: true,
    },
  );

  const GetBankName = (centerId: string) => {
    const bank = data?.find(b => b.centerId === (centerId ?? NORNE_CENTERID));
    return bank?.name ?? "";
  };

  return {
    data,
    error,
    isLoading,
    GetBankName,
  };
};

export default useAllBanks;
